<template>
  <div :id="tableFlag">
    <div class="lea-edit-table__oper">
      <!-- <span @click="add">新增</span> -->
    </div>
    <el-table :data="table" border class="param-tabele" v-loading="loading">
      <slot />
    </el-table>
  </div>
</template>

<script>
import AsyncValidator from "async-validator";
// 状态管理
import Store from "./table-store";

const PREFIX = "lea-edit-table";
let tableIdSeed = 1;

export default {
  name: "lea-edit-table",
  provide() {
    let _this = this;
    return {
      pa: _this,
      rules: this.rules
    };
  },
  // inject: ["rowData", "rules"],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    border: {
      type: Boolean
    },
    rules: Object,
    // 是否加载
    loading: {
      type: Boolean
    }
  },
  data() {
    // 创建仓库数据对象
    const store = new Store(this);
    return {
      store,
      tableFlag: "",
      table: []
    };
  },
  watch: {
    data(newValue) {
      this.table = newValue.map(item => ({ ...item, editable: false }));
    }
  },
  methods: {
    // 拼装数据
    loadData(data) {
      if (!Array.isArray(data)) {
        throw new Error("data must be an array");
      }
      return data.map(item => ({ ...item, editable: false }));
    },

    // 获取新增的数据
    getRowData() {
      return { ...this.rowData };
    },

    // 校验行数据
    validateRow(index) {
      // 获取行数据
      let row = this.table[index];
      let rules = this.rules;

      // 验证
      // let validateRuler = new Promise(function(resolve, reject) {
      let validateRuler = new Promise(function(resolve) {
        let validator = new AsyncValidator(rules);
        // validator.validate(row, { firstFields: true }, (errors, fields) => {
        validator.validate(row, { firstFields: true }, errors => {
          // console.log(fields);
          resolve(errors);
        });
      });

      return validateRuler;
    },

    // 校验表格
    validate(cb) {
      let valid = this.table.every(item => !item.editable);
      return cb && typeof cb === "function" && cb(valid);
    },

    // 格式化编辑数据
    formatData(table) {
      return table.map(item => {
        let row = { ...item };
        "editable" in row && delete row["editable"];
        return row;
      });
    },

    // 新增
    add() {
      this.table.unshift(this.getRowData());
    },

    // 暂存
    // save({ row, index }) {
    save({ index }) {
      // 校验行
      this.validateRow(index).then(err => {
        if (err) {
          this.$message.warning(err[0].message);
          return;
        }
        this.table[index].editable = false;
        // 发送
        this.$emit("on-change-row", this.formatData(this.table));
      });
    },

    // 编辑
    edit({ index }) {
      this.table[index].editable = true;
    },

    // 删除
    delete(index) {
      this.$confirm("是否需要删除该数据, 删除只会影响本次提交的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.table.splice(index, 1);
        let table = this.table.filter(col => !col.editable);
        this.$emit("on-change-row", this.formatData(table));
      });
    },

    // 发送完整数据
    // 暂时不做：因为如果删除交给组件外部做处理
    watch() {
      // console.log(this.table);
      // 比较是否有变化
      // let bigger =
      //   this.table.length >= this.data.length ? this.table : this.data;
      // let smaller =
      //   this.table.length < this.data.length ? this.table : this.data;

      for (let i = 0; i < this.table.length; i++) {
        // 查询是否每一项比对成功
      }
    }
  },
  created() {
    this.tableFlag = `${PREFIX}_${tableIdSeed}`;
    tableIdSeed += 1;
    // 装载数据
    this.table = this.loadData(this.data);
    // 监听数据变化
    this.$bus.$on("on-change-cell", ({ prop, index, value }) => {
      // 编辑行
      this.table[index][prop] = value;
      // 监视变化
      // this.watch();
    });
  }
};
</script>
